import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const commandMenuDefaultVariants = {}
const commandMenuCompoundVariants = []

const commandMenuSlotNames = [
  [
    "content",
    "commandMenu__content"
  ],
  [
    "header",
    "commandMenu__header"
  ],
  [
    "input",
    "commandMenu__input"
  ],
  [
    "list",
    "commandMenu__list"
  ],
  [
    "empty",
    "commandMenu__empty"
  ],
  [
    "item",
    "commandMenu__item"
  ],
  [
    "leftGroup",
    "commandMenu__leftGroup"
  ],
  [
    "icon",
    "commandMenu__icon"
  ],
  [
    "title",
    "commandMenu__title"
  ],
  [
    "subtitle",
    "commandMenu__subtitle"
  ],
  [
    "description",
    "commandMenu__description"
  ]
]
const commandMenuSlotFns = /* @__PURE__ */ commandMenuSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, commandMenuDefaultVariants, getSlotCompoundVariant(commandMenuCompoundVariants, slotName))])

const commandMenuFn = memo((props = {}) => {
  return Object.fromEntries(commandMenuSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const commandMenuVariantKeys = [
  "active"
]
const getVariantProps = (variants) => ({ ...commandMenuDefaultVariants, ...compact(variants) })

export const commandMenu = /* @__PURE__ */ Object.assign(commandMenuFn, {
  __recipe__: false,
  __name__: 'commandMenu',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: commandMenuVariantKeys,
  variantMap: {
  "active": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, commandMenuVariantKeys)
  },
  getVariantProps
})